import request from "@/axios.js";

export default class Mission {
	/**
	 * Mission class
	 * @param {object} mission - Object containing all information about a mission
	 * @property {string} commentary - a commentary.
	 * @property {number} price - a price.
	 * @property {string} price_text - a price(type text).
	 * @property {boolean} recurrence - an recurrence.
	 * @property {Date} timeLimit - a timeLimit.
	 * @property {number} status - a status.
	 * @property {Date} startDate - a startDate.
	 * @property {Date} endDate - an endDate.
	 * @property {Date} endDate - an estimated end date of the mission.
	 * @property {number} frequency - a frequency.
	 * @property {number} contract_id - a contract_id.
	 * @property {number} product_id - an product_id.
	 * @property {number} contract_society_id - an contract_society_id.
	 * @property {String} provider_price_text - a price for external collaborator (is String).
	 * @property {number} meeting_number - max number of meeting for mission.
	 * @property {number} max_budget - maximum budget for mission.
	 */
	constructor(mission) {
		this.id = mission.id || null;
		this.commentary = mission.commentary || null;
		this.price = mission.price || 0;
		this.price_text = mission.price_text || null;
		this.status = mission.status || 0;
		this.recurrence = mission.recurrence || 0;
		this.timeLimit = mission.timeLimit || mission.time_limit || null;
		this.start_date = mission.startDate || mission.start_date || null;
		this.end_date = mission.endDate || mission.end_date || null;
		this.estimated_end_date = mission.estimatedEndDate || mission.estimated_end_date || null;
		this.frequency = mission.frequency;
		this.contract_id = mission.contract_id || null;
		this.products_id = mission.products_id || null;
		this.contract_society_id = mission.contract_society_id || null;
		this.provider_price_text = mission.provider_price_text || null;
		this.meeting_number = mission.meeting_number || null;
		this.account_managers = mission.account_managers|| [];
		this.max_budget = mission.max_budget === "" ? null : mission.max_budget;
		this.mission_duration = mission.mission_duration || null;
		this.flexible = mission.flexible|| false;
		this.is_no_marge = mission.is_no_marge || false;
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} mission object
	 */
	static getFormFields(){
		return {
			id: null,
			commentary: null,
			price: null,
			price_text: null,
			status: 0,
			recurrence: null,
			timeLimit: null,
			start_date: null,
			end_date: null,
			estimated_end_date: null,
			frequency: null,
			contract_id: null,
			product_id: null,
			contract_society_id: null,
			provider_price_text: null,
			meeting_number: null,
			account_managers: [],
			max_budget: null,
			mission_duration: null,
			flexible: null,
			category: null,
			num_words: null,
			language: "1",
			is_no_marge: false
		};
	}

	/**
	 * Retrieve all the missions linked to a contract
	 * @param {number} contractId  - ID of the contract
	 * @param {function} callback - Callback function
	 * @returns {Mission[]} Return all the missions for a contract
	 */
	static getMissionsForContract(contractId, callback){
		request
			.get("mission/get/contract/" + contractId)
			.then(res => {
				// //console.log(res)
				callback(null, res.data);
			})
			.catch(err => callback(err, null));
	}

	/**
	 * Retrieve all the missions linked to a contract
	 * @param {number} contractId  - ID of the contract
	 * @returns {Mission[]} Return all the missions for a contract
	 */
	static async getMissionsForContractAsync(contractId){
			return new Promise((resolve, reject) => {
		request
			.get("mission/get/contract/" + contractId)
			.then(res => {
				// //console.log(res)
				resolve(res.data);
			})
			.catch(err => {
				//console.log(err);
				reject(err);
			});
		});
	}

	static getAllMissions(callback){
		request
			.get("mission/all")
			.then(res => {
				// //console.log(res)
				callback(null, res.data);
			})
			.catch(err => callback(err, null));
	}
	static async getAllMissionsAsync(){
		return new Promise((resolve, reject) => {
			request
				.get("mission/all")
				.then(res => {
					// //console.log(res)
					resolve(res.data);
				})
				.catch(err => reject(err));
		});
	}
	static async getOnlyAllMissionsAsync(){
		return new Promise((resolve, reject) => {
			request
				.get("mission/only/all")
				.then(res => {
					// //console.log(res)
					resolve(res.data);
				})
				.catch(err => reject(err));
		});
	}

	update(){
		request
			.post("mission/edit", this)
			.then(() => {
				// //console.log("update Missions", res)
				return true;
			})
			.catch(err => {
				//console.log(err);
				return false;
			});
	}


	updateUserRelation(societyId, contractId, missionId, missionOld, userId){
		return new Promise(async(resolve, reject) => {
			let resultNew = [];
			let resultDel = [];
			if(missionOld.length > 0 && this.account_managers.length > 0){
				resultNew = this.account_managers.filter(accountmanager => missionOld.filter(acc => acc.id == accountmanager.id).length == 0);
				resultDel = missionOld.filter(accountmanager => this.account_managers.filter(acc => acc.id == accountmanager.id).length == 0);
			}
			else if(missionOld.length < 1 && this.account_managers.length > 0){
				//console.log("NEW missionOld == [] && this.account_managers != []");
				resultNew = JSON.parse(JSON.stringify(this.account_managers));
			}

			else if(missionOld.length > 0 && this.account_managers.length < 1){
				//console.log("DEL missionOld != [] && this.account_managers == []");
				resultDel = JSON.parse(JSON.stringify(missionOld));
			}
			//console.log("resultNew", resultNew);
			//console.log("resultDel", resultDel);
			// let resultUpd = this.account_managers.filter(account_manager => missionOld)
			let requestsToProcess = [];

			if(resultNew.length > 0){
				for(let row of resultNew){
					requestsToProcess.push({
						action: "ADD",
						data: row,
						key: missionId,
						user: userId,
						society: societyId,
						contract: contractId
					});
				}
			}

			if(resultDel.length > 0){
				for(let row of resultDel){
					requestsToProcess.push({
						action: "DEL",
						data: row,
						key: missionId,
						user: userId,
						contract: contractId
					});
				}
			}
			//console.log("requestsToProcess", requestsToProcess);
			//console.log("processRequests BEGIN");
			await this.processRequests(requestsToProcess);
			//console.log("processRequests END");
			resolve(true);
		});
		/*
		 * let resultNew = this.account_managers.filter(accountmanager => !missionOld.includes(accountmanager))
		 * let resultDel = missionOld.filter(accountmanager => !this.account_managers.includes(accountmanager))
		 */
	}

	async processRequests(requestsToProcess){
		return new Promise((resolve, reject) => {
		try{
		let requestNumber = requestsToProcess.length;
		/*
		 * let unknownActionRequest = []
		 * let errRequest = []
		 */
		//console.log("requestNumber", requestNumber);
		if(requestNumber > 0){
			for(let request of requestsToProcess){
				if(request.action == "DEL"){
					this.deleteAM(request.user, request.contract, request.data, request.key, (err, res) => {
						if(err) console.log("Error", request, err);
						else return res;
						// if(res) //console.log(request.action, request.data, "Success");
					});
				}
				if(request.action == "ADD"){
					this.createAM(request.user, request.contract, request.society, request.data, request.key, (err, res) => {
						if(err) console.log("Error", request, err);
						return res;
						// if(res) //console.log(request.action, request.data, "Success");
					});
				}
				if(request.action != "ADD" && request.action != "DEL"){
					//console.log("Unknown Action", request);
					continue;
				}
			}
			resolve(true);
		}
		else{
			resolve(true);
		}
	}catch(err){
		console.log(err);
		reject(err);
	}
});
	}

	createAM(userId, contractId, societyId, account_manager, missionId, callback){
		//console.log("NEW", account_manager);
		//ADD Account manager
		request.post("mission/newmu", {
			mission_id: missionId,
			contract_id: contractId,
			society_id: societyId,
			users_id: account_manager.id,
			user_id: userId
		})
			.then(res => {
				//console.log(res);
				callback(null, res);
			})
			.catch(err => {
				//console.log(err);
				callback(err, null);
			});
	}

	deleteAM(userId, contractId, account_manager, missionId, callback){
		//console.log("DELETE", account_manager);
		//console.log(missionId);
		//console.log(account_manager.id);
		//DELETE Account manager
		request.delete("mission/deletemu", {
			data: {
				user_id: userId,
				contract_id: contractId,
				mission_id: missionId,
				users_id: account_manager.id
			}
		})
			.then(res => {
				//console.log(res);
				callback(null, res);
			})
			.catch(err => {
				//console.log(err);
				callback(err, null);
			});
	}

	compare(missionToCompare){
		for(let key in missionToCompare) {
			if(this[key] != missionToCompare[key]){
				return false;
			}
		}
		return true;
	}

	compareAccountManager(account_manager, account_manager_old){
		//console.log("account_manager", account_manager);
		//console.log("account_manager_old", account_manager_old);
		for(let key in account_manager_old) {
			//console.log(account_manager[key]);
			//console.log(account_manager_old[key]);
			if(account_manager[key] != account_manager_old[key]){
				return false;
			}
		}
		return true;
	}

	static delete(missionId, userId, callback) {
		request
			.delete("mission/delete", {
				data: {
					id: missionId,
					user_id: userId
				}
			})
			.then(res => {
				// //console.log(res)
				callback(null, res.data);
			})
			.catch(err => callback(err, null));
	}
}
